import React from "react";
import Cleave from "cleave.js/react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const NumberField = (props: any) => {
  const {
    placeholder,
    value,
    register,
    errors,
    label,
    setValue,
    clearErrors,
    suffix,
  } = props;
 
  return (
    <div className={tw`w-full my-2 text-left mt-4`}>
      <label htmlFor="">{label}</label>
      <div className={tw`flex w-full items-center relative `}>
        <Cleave
          type="text"
          className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
          placeholder={placeholder}
          value={value}
          autoComplete="off"
          // onBlur={() => clearErrors()}
          onChange={(e) => {setValue(register.name, e.target.value);clearErrors()}}
          disabled={register.disabled}
          options={{
            numeral: true,
            numeralDecimalMark: ".",
            numeralDecimalScale: 0,
            numeralPositiveOnly: true,
            delimiter: "",
          }}
        />
        {suffix && (
          <div className={tw`absolute right-0 w-6`}>
            <span className={tw`text-gray-600 sm:text-sm`}>{suffix}</span>
          </div>
        )}
      </div>
      {errors && (
        <p className={tw`text-red-500 text-xs my-1`}>{errors}</p>
      )}
    </div>
  );
};

export default NumberField;
